import {GeoLocation} from "./GeoLocation";
import {Name} from "./Name";

export class Address
{
	addressType = "";
	person = new Name();
	line1 = "";
	line2 = "";
	line3 = "";
	city ="";
	stateProvince = "";
	county = "";
	country = "";
	postalCode = "";
	nameOrCompany = "";
	geoLocation = new GeoLocation();
	geoLocationAccuracy = 0;
	phoneNumber = "";
}


// WEBPACK FOOTER //
// ./src/models/Address.ts